var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('comp-4-modify-goals',{attrs:{"section":12,"page":8}},[_vm._v("\n    We’re almost to the end of this of this level. Let’s revisit your goals.\n")])}
var staticRenderFns = []

export { render, staticRenderFns }